import type * as Bootstrap from 'bootstrap';

export type ModalConstructor = typeof Bootstrap.Modal;
export type ModalInstance = InstanceType<ModalConstructor>;
export type BootstrapNamespace = Partial<{
  Modal: ModalConstructor;
}>;

const ensureBootstrapNamespace = (): BootstrapNamespace => {
  if (typeof window === 'undefined') {
    throw new Error('Bootstrap helpers can only be used in the browser.');
  }

  if (!window.bootstrap) {
    throw new Error('Bootstrap JS is not loaded globally (window.bootstrap is undefined).');
  }

  return window.bootstrap;
};

const resolveBootstrapComponent = <K extends keyof BootstrapNamespace>(
  componentName: K
): NonNullable<BootstrapNamespace[K]> => {
  const namespace = ensureBootstrapNamespace();
  const component = namespace[componentName];

  if (!component) {
    throw new Error(
      `Bootstrap component "${String(componentName)}" is not available on window.bootstrap.`
    );
  }

  return component;
};

export const getBootstrapModal = (): ModalConstructor => resolveBootstrapComponent('Modal');
